import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BaseService } from '../../common/services/base.service';
import { getLanguage } from '../../common/languages';

@Injectable()
export class ProductTranslationsService extends BaseService {
    private translations  = {};

    constructor(private httpClient: HttpClient) {
        super();
    }

    findAll(): Observable<any> {
        const lang = getLanguage();
        return this.httpClient.get(this.getApiUrl() + '/translations?language=' + lang)
            .pipe(map((res: any) => this.translations = res || {}));
    }

    getLocalTranslations() {
        return this.translations;
    }

    getLocalTranslation(key: string, type: string) {
        if (this.translations && this.translations[type] && this.translations[type][key]) {
            return this.translations[type][key] || key;
        } else {
            return key;
        }
    }
}
